export default "__VITE_ASSET__MsCpVkFI__"